'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_model$package$RecipeId$() {
  this.Bi = 0;
  this.Bj = 0;
  $n_Lmealorama_model$package$RecipeId$ = this;
  $m_Lmealorama_model$package$RecipeId$();
  this.Bi = 0;
  this.Bj = 0;
}
export { $c_Lmealorama_model$package$RecipeId$ as $c_Lmealorama_model$package$RecipeId$ };
$p = $c_Lmealorama_model$package$RecipeId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_model$package$RecipeId$;
/** @constructor */
function $h_Lmealorama_model$package$RecipeId$() {
}
export { $h_Lmealorama_model$package$RecipeId$ as $h_Lmealorama_model$package$RecipeId$ };
$h_Lmealorama_model$package$RecipeId$.prototype = $p;
var $d_Lmealorama_model$package$RecipeId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_model$package$RecipeId$, "mealorama.model$package$RecipeId$", ({
  KT: 1
}));
export { $d_Lmealorama_model$package$RecipeId$ as $d_Lmealorama_model$package$RecipeId$ };
var $n_Lmealorama_model$package$RecipeId$;
function $m_Lmealorama_model$package$RecipeId$() {
  if ((!$n_Lmealorama_model$package$RecipeId$)) {
    $n_Lmealorama_model$package$RecipeId$ = new $c_Lmealorama_model$package$RecipeId$();
  }
  return $n_Lmealorama_model$package$RecipeId$;
}
export { $m_Lmealorama_model$package$RecipeId$ as $m_Lmealorama_model$package$RecipeId$ };
//# sourceMappingURL=mealorama.model$package$-Recipe-Id$.js.map
